module.exports = __webpack_public_path__ + "static/media/whiteBurger.34693d41.svg";